module.exports = __webpack_public_path__ + "img/attachmentSetting-2.c5e21dd.webp";